import {
  getUsersApi,
  getUserApi,
  postUserApi,
  patchUserApi,
  getRolesApi,
  postSendInvitationApi,
} from '@/services/users.service'
import { buildCoreApiParams } from '@/utils/table.util'

const SET_USERS = 'SET_USERS'
const SET_CURRENT_USER = 'SET_CURRENT_USER'
const SET_ROLES = 'SET_ROLES'

const getDefaultState = () => {
  return {
    users: [],
    currentUser: null,
    roles: [],
  }
}

const state = getDefaultState()

const mutations = {
  [SET_USERS]: (state, users) => {
    state.users = users
  },
  [SET_CURRENT_USER]: (state, currentUser) => {
    state.currentUser = currentUser
  },
  [SET_ROLES]: (state, roles) => {
    state.roles = roles
  },
}

const actions = {
  async getUsers({ commit }, { options, query }) {
    const urlParams = buildCoreApiParams({ options, query })
    const users = await getUsersApi(urlParams)
    commit(SET_USERS, users)
  },
  async getUser({ commit }, { params }) {
    const urlParams = buildCoreApiParams({ params })
    const currentUser = await getUserApi(urlParams)
    commit(SET_CURRENT_USER, currentUser)
  },
  async postUser(_, body) {
    await postUserApi(body)
  },
  async patchUser({ commit }, { params, body }) {
    const urlParams = buildCoreApiParams({ params })
    const currentUser = await patchUserApi(urlParams, body)
    commit(SET_CURRENT_USER, currentUser)
  },
  async getRoles({ commit }) {
    const roles = await getRolesApi()
    commit(SET_ROLES, roles)
  },
  async postUserInvitation(_, { email, token }) {
    await postSendInvitationApi({ email, token })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
